module.exports = __webpack_public_path__ + "img/st-exclaim.17081a9b.svg";